import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import ConfirmModal from "components/shared-components/ConfirmModal";
import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { useActiveBus, useInactiveBus, useListBus } from "hooks";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Row,
  DropdownToggle,
} from "reactstrap";
import { setListBusColumn } from "store/actions";
import DetailBus from "./DetailBus";
import {
  busModeList,
  busRecordStatus,
  busRecordStatusMode,
  getInitBusParams,
} from "./utils";
import useUserList from "pages/RouteManagement/useUserList";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";

const ListBus = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["bus"]);
  const [addressLevel, setAddressLevel] = useState("all");

  const {
    list: { columnsVisible: busColumnsVisible },
  } = useSelector(state => state.bus);
  const { optionUserScan } = useUserList();

  /* ================================== START INIT STATE ==================================== */

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);
  const [dataDetail, setDataDetail] = useState({ busId: null });
  const [detailModal, setDetailModal] = useState(false);
  const [inactiveBusModal, setInactiveBusModal] = useState(false);
  const [activeBusModal, setActiveBusModal] = useState(false);
  const [addressLevelFilter, setAddressLevelFilter] = useState({
    value: "all",
    label: "Tất cả",
  });

  const [isOpenAddrFilter, setIsOpenAddrFilter] = useState(false);

  // Filter options
  const addressLevelFilterOptions = [
    { value: "all", label: "Tất cả" },
    { value: "2", label: "2 cấp" },
    { value: "3", label: "3 cấp" },
  ];

  const handleAddressLevelFilterChange = selectedOption => {
    if (addressLevelFilter.value === selectedOption.value) return;

    setAddressLevelFilter(selectedOption);
    setAddressLevel(selectedOption.value);

    setBusParams(prev => {
      const currentFilter = { ...prev.columnFilter };
      const currentFilterKeep = { ...prev.columnFilterKeep };

      if (selectedOption.value === "2") {
        currentFilter["filter[is_new_address]"] = "N";
        currentFilterKeep["filter[is_new_address]"] = "N";
      } else if (selectedOption.value === "3") {
        currentFilter["filter[is_new_address]"] = "O";
        currentFilterKeep["filter[is_new_address]"] = "O";
      } else {
        delete currentFilter["filter[is_new_address]"];
        delete currentFilterKeep["filter[is_new_address]"];
      }

      return {
        ...prev,
        columnFilter: currentFilter,
        columnFilterKeep: currentFilterKeep,
        page: 1,
        run: true,
      };
    });
  };
  const [busParams, setBusParams] = useState({
    ...getInitBusParams(),
    expand: "maker,checker,hub",
    columnFilterKeep: {
      // "filter[record_status]": "O",
    },
    columnFilter: {
      // "filter[record_status]": "O",
    },
  });

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  const handleChangeAddressLevel = value => {
    setAddressLevel(value);

    setBusParams(prev => {
      const newFilter = { ...prev.columnFilterKeep };

      if (value === "2") {
        newFilter["filter[is_new_address]"] = "N";
      } else if (value === "3") {
        newFilter["filter[is_new_address]"] = "O";
      } else {
        delete newFilter["filter[is_new_address]"];
      }

      return {
        ...prev,
        columnFilter: newFilter,
        columnFilterKeep: newFilter,
        page: 1,
      };
    });
  };
  // BUS LIST
  const {
    isFetching: isLoading,
    data: busList,
    refetch: listBus,
  } = useListBus({ params: busParams });

  // ACTIVE BUS
  const handleActiveBus = () => {
    listBus();
  };

  const { mutate: activeBus } = useActiveBus(handleActiveBus, handleActiveBus);

  // INACTIVE BUS
  const handleDeleteBus = () => {
    listBus();
  };

  const { mutate: inactiveBus } = useInactiveBus(
    handleDeleteBus,
    handleDeleteBus
  );

  useEffect(() => {
    if (busParams && busParams.run) {
      listBus();
    }
  }, [busParams]);

  useEffect(() => {
    initColumn();
  }, [t, optionUserScan, addressLevel]);

  useEffect(() => {
    if (busList) {
      initColumn();
    }
  }, [busList, addressLevel]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const initColumn = () => {
    if (busColumnsVisible && Object.keys(busColumnsVisible).length > 0) {
      initColumns.forEach(item => {
        if (busColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !busColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListBusColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "bus") {
          options = busRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "bus") {
          options = busRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setBusParams(prev => {
      const infrastructureFilters = {};

      if (prev.columnFilterKeep["hub_ids"]) {
        infrastructureFilters["hub_ids"] = prev.columnFilterKeep["hub_ids"];
      }

      if (prev.columnFilterKeep["filter[is_new_address]"]) {
        infrastructureFilters["filter[is_new_address]"] =
          prev.columnFilterKeep["filter[is_new_address]"];
      }

      const mergedFilter = {
        ...infrastructureFilters,
        ...columnFilter,
      };

      const newColumnFilterKeep = {
        ...infrastructureFilters,
        ...columnFilter,
      };

      return {
        ...prev,
        sort: sortField ? sortOrder + sortField : prev.sort,
        columnFilter: mergedFilter,
        columnFilterKeep: newColumnFilterKeep,
        page: page || 1,
        sizePerPage: sizePerPage || 10,
        run: true,
      };
    });
  };

  const onSearchAllHandle = value => {
    setBusParams(prev => ({
      ...prev,
      keywords: value,
      run: true,
    }));
  };

  // INACTIVE
  const toggleInactiveBusModal = () => {
    setInactiveBusModal(!inactiveBusModal);
  };

  const onClickInactiveBus = (row, index) => {
    setDataDetail({ busId: row.id });
    toggleInactiveBusModal();
  };

  const confirmInactiveBusHandler = () => {
    inactiveBus({
      busId: dataDetail.busId,
      data: { record_status: busRecordStatusMode.INACTIVE },
    });
    toggleInactiveBusModal();
  };

  // ACTIVE
  const toggleActiveBusModal = () => {
    setActiveBusModal(!activeBusModal);
  };

  const onClickActiveBus = (row, index) => {
    setDataDetail({ busId: row.id });
    toggleActiveBusModal();
  };

  const confirmActiveBusHandler = () => {
    activeBus({
      busId: dataDetail.busId,
      data: { record_status: busRecordStatusMode.ACTIVE },
    });
    toggleActiveBusModal();
  };

  // DETAIL
  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case busModeList.EDIT_BUS_DETAIL:
        listBus();
        break;
      default:
        break;
    }
  };

  const clickEditBusHandler = (row, index) => {
    setDataDetail({ busId: row.id });
    setMode(busModeList.EDIT_BUS_DETAIL);
    toggleDetailModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ busId: row.id });
      setMode(busModeList.VIEW_BUS_DETAIL);
      toggleDetailModal();
    },
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const listRowAction = [
    {
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.bus"),
      onClick: clickEditBusHandler,
    },
    {
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("table.actions.delete.bus"),
      conditionVisible: {
        record_status: [busRecordStatusMode.ACTIVE],
      },
      onClick: onClickInactiveBus,
    },
    {
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("table.actions.active.bus"),
      conditionVisible: {
        record_status: [busRecordStatusMode.INACTIVE],
      },
      onClick: onClickActiveBus,
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "address_type",
      text: "Loại địa chỉ",
      sort: false,
      align: "center",
      hidden: addressLevel !== "all",
      formatter: (_cell, row) => {
        const isRowLevel2 =
          row?.is_new_address === "N" ||
          (!row?.ward_name && row?.district_name);
        return (
          <span
            className={`badge ${isRowLevel2 ? "bg-info" : "bg-secondary"}`}
            style={{ fontSize: "11px", padding: "4px 8px" }}
          >
            {isRowLevel2 ? "2 cấp" : "3 cấp"}
          </span>
        );
      },
      headerStyle: { textAlign: "center", minWidth: "100px" },
    },
    {
      dataField: "name",
      text: t("table.name"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.name"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "phone_number",
      text: t("table.phone_number"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.phone_number"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "address",
      text: t("table.address"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.address"),
        }),
      }),
      sort: true,
      formatter: (cell, row) => {
        let address = row.address;
        const isLevel2 = row.is_new_address === "N";

        if (isLevel2) {
          address +=
            (row.district_name ? ", " + row.district_name : "") +
            (row.province_name ? ", " + row.province_name : "");
        } else {
          address +=
            (row.ward_name ? ", " + row.ward_name : "") +
            (row.district_name ? ", " + row.district_name : "") +
            (row.province_name ? ", " + row.province_name : "");
        }

        return address;
      },
      allowExport: true,
    },
    {
      dataField: "hub_id",
      text: "Center/Hub",
      sort: true,
      formatter: (cell, row) => {
        return row?.hub?.name;
      },
    },
    {
      dataField: "record_status",
      text: t("table.record_status.bus.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.bus.name"),
        }),
        options: selectOptionsTable(undefined, "record_status", "bus"),
      }),
      formatter: (cell, row) => {
        if (cell && busRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "bus");
        } else {
          return "";
        }
      },
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={busParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: true,
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      allowExport: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={busParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={busParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      allowExport: true,
    },
  ];

  const addressLevelOptions = [
    { value: "all", label: "Tất cả" },
    { value: "2", label: "2 cấp" },
    { value: "3", label: "3 cấp" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${busList?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Bus Modal */}
              <DetailBus
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
              />
              {/* Delete Bus Modal */}
              <ConfirmModal
                isOpen={inactiveBusModal}
                titleHeader={t("form.submit.delete.bus.confirm.header")}
                titleBody={t("form.submit.delete.bus.confirm.body")}
                onConfirm={confirmInactiveBusHandler}
                textBtnConfirm={t("form.submit.delete.bus.confirm.agree")}
                textBtnCancel={t("form.submit.delete.bus.confirm.cancel")}
                toggle={toggleInactiveBusModal}
              />
              {/* Active Bus Modal */}
              <ConfirmModal
                isOpen={activeBusModal}
                titleHeader={t("form.submit.active.bus.confirm.header")}
                titleBody={t("form.submit.active.bus.confirm.body")}
                onConfirm={confirmActiveBusHandler}
                textBtnConfirm={t("form.submit.active.bus.confirm.agree")}
                textBtnCancel={t("form.submit.active.bus.confirm.cancel")}
                toggle={toggleActiveBusModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    keyField="id"
                    data={busList?.items || []}
                    columns={columnsTable}
                    page={busParams.page}
                    sizePerPage={busParams.sizePerPage}
                    totalSize={busList?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={isLoading}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <div style={{ minWidth: 100 }}>
                        <Dropdown
                          isOpen={isOpenAddrFilter}
                          toggle={() => setIsOpenAddrFilter(!isOpenAddrFilter)}
                        >
                          <DropdownToggle
                            className="btn primary-btn w-100 text-overflow"
                            caret
                          >
                            Địa chỉ
                            <span>:&nbsp;{addressLevelFilter.label}</span>
                            <i className="mdi mdi-chevron-down" />
                          </DropdownToggle>
                          <DropdownMenu
                            className="w-100"
                            style={{ minWidth: 100 }}
                          >
                            {addressLevelFilterOptions.map(opt => (
                              <DropdownItem
                                key={opt.value}
                                onClick={() =>
                                  handleAddressLevelFilterChange(opt)
                                }
                              >
                                {opt.label}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </div>

                      <HubFilter
                        mainFilterParams={busParams}
                        setMainFilterParams={setBusParams}
                        isFilterAllDefault={true}
                        isHaveAllOption={true}
                        isNotFilterChildHub={true}
                        addressLevel={
                          addressLevel === "all"
                            ? 3
                            : addressLevel === "2"
                            ? 2
                            : 3
                        }
                      />

                      <Link
                        to="/bus/create"
                        className="btn btn-primary btn-label"
                      >
                        <i className="fas fa-plus label-icon" />
                        {t("title.create")}
                      </Link>
                    </div>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListBus;
